<svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14">
  <g fill="none" fill-rule="evenodd" transform="translate(0 1)">
    <path [attr.fill]="color" d="M0 6.175L3.8 2.83a8 8 0 0 1 10.707.124L18 6.175l-3.717 3.172a8 8 0 0 1-10.245.117L0 6.174z"/>
    <circle cx="9" cy="6" r="3" [attr.fill]="color" stroke="#FFF" stroke-width="2"/>
    <path [attr.stroke]="color" stroke-linecap="round" stroke-width="2" d="M15.5.5l-13 11"/>
  </g>
</svg>
